document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM content loaded");

  // Find the existing Swiper instance
  const mainSwiperElement = document.querySelector(".product-images .swiper");
  const mainSwiper = mainSwiperElement?.swiper;

  if (!mainSwiperElement) {
    return;
  }

  console.log("Main Swiper found:", mainSwiper);

  const thumbnails = document.querySelectorAll(".thumbnail");
  console.log("Thumbnails found:", thumbnails.length);

  function updateActiveThumbnail(activeIndex) {
    console.log("Updating active thumbnail:", activeIndex);
    thumbnails.forEach((thumbnail, index) => {
      if (index === activeIndex) {
        thumbnail.classList.add("active");
      } else {
        thumbnail.classList.remove("active");
      }
    });
  }

  // Update active thumbnail when slide changes
  mainSwiper.on("slideChange", function () {
    console.log("Slide changed to:", mainSwiper.realIndex);
    updateActiveThumbnail(mainSwiper.realIndex);
  });

  // Add click event listeners to thumbnails
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", () => {
      console.log("Thumbnail clicked:", index);
      mainSwiper.slideTo(index);
    });
  });

  // Initialize the first thumbnail as active
  updateActiveThumbnail(mainSwiper.realIndex);
});
